<template lang="pug">
modal.add-team-user-modal(
  :close-button-label='$t("button.cancel")'
  :disableProcessButton='!selectedUsers.length'
  :loading='loading'
  :process-button-label='$t("button.add")'
  :title='$t("modal.addTeamUser.title")'
  @closed='onCloseModal'
  @opened='loadData'
  @process='process'
  ref='modal'
  size='lg'
)
  .col-12.col-sm-6
    .form-group.input-search-recipient
      .form-control-icon--end-line
        input#search-users.form-control(
          :placeholder='$t("placeholder.search_user")'
          @keyup='onSearchUsers()'
          autocomplete='off'
          type='text'
          v-model.trim='queryUser'
        )
        icon(name='magnifying-glass')
  .user-list
    .row.gx-3.gy-2
      .col-4(:key='index' v-for='(user, index) in users.data')
        label.user-list-item(:for='`user-input-${index}`')
          input.checkbox.form-check-input(
            :checked='userIsSelected(user)'
            :id='`user-input-${index}`'
            @change='triggerItem(user)'
            type='checkbox'
          )
          .user-info.d-flex.flex-column.ms-2
            span.text {{ user.name }}
            span.text {{ user.email }}
    simple-paginator.pagination-space.mt-4(
      :payload='users'
      @navigate='listUsers'
    )
  .text-center.mt-3(v-if='!hasUsers && queryUser')
    img.img(src='/img/ilustrations/no-contacts-found.svg')
    p.font-color-blue.mt-4 {{ $t('message.no_results_found') }}
  .text-center.mt-3(v-if='!hasUsers && !queryUser')
    img.img(src='/img/ilustrations/no-contacts.svg')
    p.font-color-blue.mt-4 {{ $t('message.no_users_stored') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import UsersService from '@/services/UsersService';
import Icon from '@/ui/atoms/Icon.vue';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import debounce from 'debounce';

export default {
  name: 'AddTeamUserModal',
  components: {
    Modal,
    Icon,
    SimplePaginator,
  },
  props: {
    teamId: {
      type: String,
      default: '',
    },
    existingUserIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      queryUser: '',
      users: {
        data: [],
        links: {},
        meta: {},
      },
      selectedUsers: [],
    };
  },
  computed: {
    hasUsers() {
      return this.users.data.length > 0;
    },
  },
  methods: {
    async loadData() {
      await this.listUsers();
    },
    async listUsers(page = 1) {
      this.loading = true;
      this.$loading(true);
      const params = new URLSearchParams({
        q: this.queryUser,
        page,
      });
      const response = await UsersService.list(params);
      let fetchedUsers = response.data.data || [];
      fetchedUsers = fetchedUsers.filter((u) => !u.is_owner);
      if (this.existingUserIds.length) {
        fetchedUsers = fetchedUsers.filter(
          (u) => !this.existingUserIds.includes(u.id)
        );
      }
      this.users = {
        ...response.data,
        data: fetchedUsers,
      };
      this.loading = false;
      this.$loading(false);
    },
    onCloseModal() {
      this.queryUser = '';
      this.selectedUsers = [];
    },
    process() {
      this.$emit('selected-users', { users: this.selectedUsers });
      this.$refs.modal.close();
    },
    triggerItem(user) {
      const hasUser = this.selectedUsers.find((item) => item.id === user.id);
      if (hasUser) {
        this.selectedUsers = this.selectedUsers.filter(
          (item) => item.id !== user.id
        );
      } else {
        this.selectedUsers.push(user);
      }
    },
    userIsSelected(user) {
      return this.selectedUsers.some((item) => item.id === user.id);
    },
    onSearchUsers: debounce(function search() {
      this.listUsers();
    }, 500),
  },
};
</script>
<style lang="stylus">
.user-list-item
  border-radius: 3px
  padding: 0.54rem 1rem
  box-shadow: 0px 0px 3px 1px #dadada
  cursor: pointer
  position: relative
  padding-left: 1.7rem
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  color: #555555
  width: 100%
  font-size: 0.875rem
  .checkbox
    position: absolute
    left: 7px
    top: 0.7rem
.input-search-recipient
  width: 16.25rem
  input
    border-radius: 0.313rem
  .icon
    top: 0.8em
    font-size: 1.25rem
.pagination-space
  display: inline-block
</style>
